import dayjs from 'dayjs';

import type { ExportSettingsType } from '@/features/DataHub/modules/Export/types';
import { parseRelativeDateSelection } from '@/utils/parseRelativeDateSelection';

export function getXAxisRangeStrings(exportSettings: ExportSettingsType) {
  let from = undefined;
  let to = undefined;

  if (exportSettings.dateRangeType === 'dates') {
    from = exportSettings.from && dayjs(exportSettings.from).format('YYYY-MM-DD');
    to = exportSettings.to && dayjs(exportSettings.to).format('YYYY-MM-DD');
  }
  if (exportSettings.dateRangeType === 'range') {
    const relativeDate = parseRelativeDateSelection(
      Number(exportSettings.periodNumber),
      exportSettings.period
    );
    from = dayjs(relativeDate).format('YYYY-MM-DD');
  }
  const xAxisMin = from ? new Date(from).getTime() : undefined;
  const xAxisMax = to ? new Date(to).getTime() : undefined;
  return { xAxisMin, xAxisMax };
}
